import axios from '@/axiosConnection'
export default {
  namespaced: true,
  state: {
    items: [],
    itemsCurrent: []
  },
  getters: {
    getAll: state => {
      return state.items
    },
    getAllCurrent: state => {
      return state.itemsCurrent
    },
    getByCategory: state => family_id => state.itemsCurrent.filter(item => item.family.id == family_id),
    getItemCurrent: state => id => state.itemsCurrent.find(item => item.id == id),
    getItem: state => id => state.items.find(item => item.id == id)
  },
  mutations: {
    setAllCurrent(state, itemsCurrent) {
      state.itemsCurrent = itemsCurrent
    },
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   boolean wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns promise       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'product',
        api_data_path: 'products',
        namespace: 'product'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les produits dont available == 1 via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   boolean wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns promise       Aucune donnée n'est retournée
     */
    getAllAvailable: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'product/available',
        api_data_path: 'products',
        namespace: 'product'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getAllCurrent: (context, wait = false) => {
      return new Promise(function (resolve, reject) {
        if (wait == false && context.state.itemsCurrent && context.state.itemsCurrent.length) {
          resolve()
        }
        axios.get('product/current')
          .then(response => {
            context.commit('setAllCurrent', response.data);

            resolve()
          })
          .catch(error => {
            reject()
          })
      })
    },
     addItem(context, item) {
       let params = {
         api_url: 'product',
         namespace: 'product',
         item: item
       }
       return context.dispatch('addItem', params, {
         root: true
       })
     },
     saveItem(context, item) {
       let params = {
         api_url: 'product',
         namespace: 'product',
         item: item
       }
       return context.dispatch('saveItem', params, {
         root: true
       })
     },
     deleteItem(context, id) {
       let params = {
         api_url: 'product',
         namespace: 'product',
         id: id
       }
       return context.dispatch('deleteItem', params, {
         root: true
       })
     }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/product.js